import { render, staticRenderFns } from "./DonutChart.vue?vue&type=template&id=1f2913d0&scoped=true"
import script from "./DonutChart.vue?vue&type=script&lang=ts"
export * from "./DonutChart.vue?vue&type=script&lang=ts"
import style0 from "./DonutChart.vue?vue&type=style&index=0&id=1f2913d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2913d0",
  null
  
)

export default component.exports